// extracted by mini-css-extract-plugin
export default {"ContentLoader":"ContentLoader_ContentLoader__fu9XQ","ContentLoader__image":"ContentLoader_ContentLoader__image__uyE97","spin":"ContentLoader_spin__k-IPs"};